<template>
    <div class="mx-8">
        <v-server-table
            :url="apiUrl"
            :columns="columns.data"
            :options="options"
            :name="showEndPoint"
            ref="table"
            @loaded="tableLoaded"
            @row-click="rowClicked"
        >
            <template v-slot:status="props">
                <slot name="status" :props="props">
                    <div class="">
                        <span v-if="props.row.status == '1'">Aktivno</span>
                        <span v-else>Neaktivno</span>
                    </div>
                </slot>
            </template>
            <template v-slot:tech_users="props">
                <slot name="tech_users" :props="props">
                    <div class="">
                        <span v-if="props.row.tech_users == '1'">Tehničko osoblje</span>
                        <span v-else>Standardno osoblje</span>
                    </div>
                </slot>
            </template>
            <template v-slot:available="props">
                <slot name="available" :props="props">
                    <div class="">
                        <span v-if="props.row.available == '1'">Raspoloživ</span>
                        <span v-else>Neraspoloživ</span>
                    </div>
                </slot>
            </template>
            <template v-slot:actions="props">
                <slot name="actions" :props="props">
                    <div class="flex">
                        <a class="ml-auto text-primary" :href="route(showEndPoint + '.show', props.row.id)">
                            <img src="/svg/list_arrow.svg" alt=">">
                        </a>
                    </div>
                </slot>
            </template>
            <template v-slot:deleted_at="props">
                <slot name="deleted_at" :props="props">{{ props.row.deleted_at ? 'Neaktivan' : 'Aktivan' }}</slot>
            </template>
        </v-server-table>
        <div class="absolute top-0 left-0 flex mt-12 ml-20">
            <img class="pr-3" src="/assets/icon_search.svg" alt="Search" />
            <input
                class="h-full menu-search"
                type="text"
                placeholder="Pretražite pojam iz tablice"
                @input="searchQuery"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            default: () => ([]),
        },
        columns: {
            required: true,
            type: Object,
        },
        apiUrl: {
            required: true,
            type: String,
        },
        perPage: {
            type: Number,
            default: null,
        },
        sortColumn: {
            type: String,
            default: null,
        },
        sortType: {
            type: String,
            default: 'asc',
        },
        showEndPoint: {
            required: true,
            type: String,
        },
        editEndPoint: {
            type: Boolean,
            default: false,
        },
        initialFilter: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        const vm = this;
        const url = new URL(window.location.href);
        const pageFromUrl = parseInt(url.searchParams.get("page") || "1");
        return {
            options: {
                initialPage: pageFromUrl,
                texts: {
                    filterPlaceholder: 'Search',
                    limit: 'Items per page: ',
                    count: '{count} zapisa',
                    noResults: 'Ne postoje zapisi',
                    loading: 'Učitavam...',
                    first: 'Prva',
                    last: 'Zadnja',
                },
                pagination: {
                    chunk: 10,
                    edge: true,
                },
                perPageValues: [],
                customFilters: ['filters'],
                serverMultiSorting: true,
                resizableColumns: false,
                requestFunction(data) {
                    const innerQuery = (vm.$refs.table && vm.$refs.table.$refs && vm.$refs.table.$refs.table)
                        ? (vm.$refs.table.$refs.table.query || '')
                        : '';

                    const params = Object.assign({}, data, { query: innerQuery });
                    return window.axios.get(vm.apiUrl, { params: params });
                },
            },
        };
    },

    created() {
        this.showLoader();

        window.axios.defaults.headers.Authorization = `Bearer ${window.App.user.api_token}`;
        window.axios.defaults.headers.Accept = 'application/json';

        if (this.filters) {
            this.options.initFilters = { filters: [] };
            this.filters.forEach(filter => {
                this.options.initFilters.filters.push({
                    model: filter.model,
                    column: filter.column,
                    value: filter.value,
                });
            });
        }

        if (this.initialFilter.model) {
            this.options.initFilters = {
                role: {
                    column: this.initialFilter.column,
                    value: this.initialFilter.value,
                },
            };
        }

        if (this.columns && this.columns.headings) {
            this.options.headings = this.columns.headings;
        }

        if (this.perPage) {
            this.options.perPage = this.perPage;
        }

        if (this.sortColumn) {
            this.options.orderBy = {
                ascending: this.sortType === 'asc',
                column: this.sortColumn,
            };
        }
    },

    mounted() {
        window.Bus.$on('search-query', payload => {
            Event.$emit('vue-tables.filter::query', payload);
        });

        Event.$on(`vue-tables.${this.showEndPoint}.pagination`, page => {
            localStorage.setItem(`${this.showEndPoint}_last_page`, page);
        });
    },

    destroyed() {
        window.Bus.$emit('dataTableLoaded', { loaded: false });
    },

    methods: {
        searchQuery(e) {
            const value = e && e.target ? e.target.value : '';

            if (this.$refs.table && typeof this.$refs.table.setFilter === 'function') {
                this.$refs.table.setFilter(value);
                return;
            }

            Event.$emit('vue-tables.filter::query', value);
        },

        rowClicked(props) {
            const page = localStorage.getItem(`${this.showEndPoint}_last_page`) || 1;
            window.location.href = route(
                this.editEndPoint ? `${this.showEndPoint}.edit` : `${this.showEndPoint}.show`,
                props.row.id
            ) + `?page=${page}`;
        },

        tableLoaded() {
            this.hideLoader();
            window.Bus.$emit('dataTableLoaded', { loaded: true });
        },
    },
};
</script>

<style lang="scss">
</style>
